import React, { useRef, useState } from "react";
import { FormattedDate, FormattedMessage, useIntl } from "react-intl";
import { Popper } from "@material-ui/core";
import Button from "../button/button";
import Search from "../search/search";
import "./filter.css";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import FollowUpEntryFormField from "../../workOrderActions/followUpEntryFormField";
/*
    Filter box dropdown for sorting/filtering data
    props:
        - data: array, list of data
        - field: {fieldName, label}, object representing the field to filter on
        - filtering: {order, field, selectedItems}, object represented selected filter options
        - clickFnApply: (value) => void
            callback with filter settings on click of Apply button
        - clickFnClose: () => void
            callback to close filter dropdown and clear selected filter values on click of Cancel button 
*/
const Filter = ({ rows, field, filter, clickFnApply, clickFnClose, anchor }) => {
    const intl = useIntl();
    const sortFunction = (valOpts, fieldType) => {
        switch (fieldType) {
            case "date":
                return valOpts.sort((v1, v2) => new Date(v1) - new Date(v2));
            case "alphaNumeric":
                return valOpts.sort((a, b) => a.localeCompare(b, intl.locale, { numeric: true }));
            case "text":
                return valOpts.sort((val1, val2) => val1.localeCompare(val2, intl.locale, { sensitivity: "base" }));
            case "numeric":
                return valOpts.sort((val1, val2) => val1 - val2);
            default:
                return valOpts.sort();
        }
    };
    // Creates array of valid options for the filter dropdown
    var valOpts = [];
    if (rows.length > 0) {
        const dataSet = new Set(
            rows.map((row) => {
                var value = row[field.field];
                if (field.valueFormatter) {
                    value = field.valueFormatter({
                        value,
                        row,
                    });
                }
                return value === null ? "" : value;
            }),
        );
        valOpts = [...dataSet];
        sortFunction(valOpts, field.fieldType);
    }
    var order = true;
    var selectedButton = null;
    var items = [];

    // Reapply the filtering that was used on next re-open of the Filter dropdown
    if (filter && filter.field.field === field.field) {
        order = filter.order === "asc" ? true : false;
        selectedButton = order ? "asc" : "desc";
        items = filter.selectedItems;
    }

    const [search, setSearch] = useState("");
    const [orderAsc, setOrderAsc] = useState(order);
    const [selectedBtn, setSelectedBtn] = useState(selectedButton);
    const [valOptions, setvalOptions] = useState(valOpts);
    const [selectedItems, setSelectedItems] = useState(items);

    const handleSearch = (value) => {
        if ("phoneNumber" === field.field || "customerPhoneNumber" === field.field) {
            var phoneValue = value.replaceAll("-", "");
            phoneValue = phoneValue.replaceAll(" ", "");
            phoneValue = phoneValue.replaceAll("(", "");
            phoneValue = phoneValue.replaceAll(")", "");
            var finalPhone = phoneValue;
            if (phoneValue.length > 3) {
                finalPhone = phoneValue.substring(0, 3);
                finalPhone = finalPhone + "-";
                if (phoneValue.length >= 6) {
                    finalPhone = finalPhone + phoneValue.substring(3, 6) + "-";
                    if (phoneValue.length > 6) {
                        finalPhone = finalPhone + phoneValue.substring(6, phoneValue.length);
                    }
                } else {
                    finalPhone = finalPhone + phoneValue.substring(3, phoneValue.length);
                }
            }
            if (phoneValue.length === 4) {
                finalPhone = finalPhone + "," + phoneValue;
            }
            setSearch(finalPhone.toString());
        } else {
            setSearch(value.toString());
        }
    };

    const handleOrderSelect = (orderAsc) => {
        if (orderAsc) {
            setSelectedBtn("asc");
        } else {
            setSelectedBtn("desc");
        }
        setOrderAsc(orderAsc);
    };

    const handleApply = () => {
        var filtering = {
            order: selectedItems ? (orderAsc ? "asc" : "desc") : null,
            field,
            selectedItems,
        };
        clickFnApply(filtering);
    };

    const handleCancel = () => {
        clickFnClose();
    };

    const handleCheckboxSelection = (opt) => {
        selectItems(opt);
    };

    // Sets the list of selected items from filter value list
    const selectItems = (item) => {
        // Need to specify it as === null to support empty string filtering
        if (item === null || item === undefined) {
            return selectedItems;
        }
        var curItems = selectedItems;

        var index = valOptions.findIndex((i) => i === item);
        if (index < 0) return selectedItems;

        if (!curItems.includes(valOptions[index])) {
            if (valOptions[index] != null) {
                setSelectedItems([...curItems, valOptions[index]]);
            }
        } else {
            setSelectedItems(curItems.filter((item) => item !== valOptions[index]));
        }
    };

    // Determines which button to show as "selected" after filtering has been applied at least once on this field
    var ascBtnSelected = false,
        descBtnSelected = false;
    if (selectedBtn === "asc") {
        ascBtnSelected = true;
    } else if (selectedBtn === "desc") {
        descBtnSelected = true;
    }

    const checkboxItems = selectItems(null);
    const open = Boolean(anchor);
    const id = open ? "simple" : undefined;
    // valOpts.sort();
    return (
        <ClickAwayListener onClickAway={clickFnClose}>
            <Popper
                id={id}
                open={open}
                anchorEl={anchor}
                placement="bottom-start"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                }}
                popperOptions={{
                    positionFixed: true,
                }}
                style={{ zIndex: "3000" }}>
                <div className={"filter-container"} data-testid="filter-dropdown">
                    <div className="filter-contents">
                        <div className="filter-header">
                            <FormattedMessage id="filter.sort-header" defaultMessage="Sort" description="Filter Sort Header" />
                        </div>
                        <div className="filter-btns">
                            <div data-testid="filter-ascend">
                                <Button secondary={ascBtnSelected} tertiary={!ascBtnSelected} default onClick={() => handleOrderSelect(true)}>
                                    <FormattedMessage
                                        id="filter.ascending-button-caption"
                                        defaultMessage="Ascending"
                                        description="Ascending button caption"
                                    />
                                </Button>
                            </div>
                            <div data-testid="filter-descend">
                                <Button secondary={descBtnSelected} tertiary={!descBtnSelected} default onClick={() => handleOrderSelect(false)}>
                                    <FormattedMessage
                                        id="filter.descending-button-caption"
                                        defaultMessage="Descending"
                                        description="Descending button caption"
                                    />
                                </Button>
                            </div>
                        </div>
                        <hr />

                        <div className="filter-header">
                            <FormattedMessage id="filter.filter-title" defaultMessage="Filter" description="Filter title" />
                        </div>
                        <Search filter onSearch={(val) => handleSearch(val)}></Search>

                        <div className="filter-checkbox">
                            <ul>
                                {valOptions && valOptions.length > 0
                                    ? valOptions
                                          .filter((option) => {
                                              const optionTextVal = option?.toString();
                                              const optionText = option?.toString().toLocaleLowerCase();
                                              const searchText = search?.toLocaleLowerCase();
                                              var searchValue = search?.split(",");
                                              if (searchText?.includes(",")) {
                                                  return (
                                                      (optionText?.includes(searchValue[0]) && optionText?.includes(searchValue[1])) ||
                                                      (optionTextVal?.includes(searchValue[0]) && optionTextVal?.includes(searchValue[1]))
                                                  );
                                              } else {
                                                  return optionText?.includes(searchText) || optionTextVal?.includes(searchText);
                                              }
                                          })
                                          .map((opt, i) => (
                                              <li key={i}>
                                                  <input
                                                      checked={checkboxItems?.includes(opt)}
                                                      name={opt?.toString()}
                                                      type="checkbox"
                                                      onChange={(e) => handleCheckboxSelection(opt)}
                                                      data-testid={"filter-checkbox-" + field.fieldName + "-" + opt}
                                                  />
                                                  <span className="items">{opt}</span>
                                              </li>
                                          ))
                                    : null}
                            </ul>
                        </div>

                        <hr />
                        <div className="filter-btns">
                            <span data-testid="filter-cancel">
                                <Button tertiary default onClick={() => handleCancel()}>
                                    <FormattedMessage id="filter.cancel-button-caption" defaultMessage="Cancel" description="Cancel button caption" />
                                </Button>
                            </span>
                            <span style={{ marginLeft: "16px" }} data-testid="filter-apply">
                                <Button disabled={!selectedBtn && checkboxItems.length === 0} primary default onClick={() => handleApply()}>
                                    <FormattedMessage id="filter.accept-button-caption" defaultMessage="Apply" description="Apply button caption" />
                                </Button>
                            </span>
                        </div>
                    </div>
                </div>
            </Popper>
        </ClickAwayListener>
    );
};

export default Filter;
